import "antd/dist/reset.css";
import "./styles/index.scss";
import CustomRoutes from "./Routes/Routes";
import ProtectedRoute from "./Routes/ProtectedRoute";
import Login from "./pages/login";
import ForgotPassword from "./pages/forgotpassword";
import SignUp from "./pages/signUp";
import CreateAccount from "./pages/CreateAccount";
import Welcome from "./pages/Welcome/index";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import OnBoardingForm from "./pages/OnBoardingForm/OnBoardingForm";
import Aboutus from "./pages/AboutUs/Aboutus";
import TermsOfUse from "./pages/TermsOfUse/TermsOfUse";
import ErrorPage from "./components/common/ErrorPage";
import Contactus from "./pages/ContactUs/Contactus";
import VerifyOtp from "./pages/veryOtp/VerifyOtp";
import { Provider } from "react-redux";
import store from "./store/store";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import SetYourPassword from "./pages/setYourPassword";
import UserInvite from "./pages/userInvite";
import Chat from "./pages/Chat/ChatWithLayout";
import API_MANAGER from "./API";
import { IsTokenValid } from "./utils/middleware";
import { message } from "antd";
import NoInternetError from "./components/common/NoInternetError";
import SessionExpired from "./components/common/SessionExpired";

function App() {
  
  const INACTIVITY_TIMEOUT = 10800; 
  const [seconds, setSeconds] = useState(INACTIVITY_TIMEOUT);
  const navigate = useNavigate();
  
  const getUserData = async () => {
    try {
      const response = await API_MANAGER.getLocalData();
      setSeconds(INACTIVITY_TIMEOUT);
      if (response?.data?.data?.user && response?.data?.data?.recruiter) {
        localStorage.setItem(
          "name",
          response?.data?.data?.user?.firstName +
            " " +
            response?.data?.data?.user?.lastName
        );
        localStorage.setItem("userEmail", response?.data?.data?.user?.email);
        localStorage.setItem("userID", response?.data?.data?.user?.id);
        localStorage.setItem(
          "createdAt",
          response?.data?.data?.user?.createdAt
        );
        const userType = response?.data?.data?.user?.recruiterUserType
          ? response?.data?.data?.user?.recruiterUserType !== "Standard"
            ? response?.data?.data?.user?.recruiterUserType
            : "Account"
          : "Root";
        localStorage.setItem("user", userType);
        localStorage.setItem("clientId", response?.data?.data?.recruiter?._id);
        if (
          response?.data?.data?.recruiter?.subscription?.sp?.plusSubscription
        ) {
          localStorage.setItem(
            "isPlusSubscription",
            response?.data?.data?.recruiter?.subscription?.sp?.plusSubscription
          );
        } else {
          localStorage.setItem("isPlusSubscription", false);
        }
        console.log(
          response?.data?.data?.recruiter?.subscription,
          "response?.data?.data?.recruiter"
        );
        if (response?.data?.data?.recruiter?.subscription) {
          localStorage.setItem(
            "subscription",
            JSON.stringify(response?.data?.data?.recruiter?.subscription)
          );
        } else {
          localStorage.setItem("subscription", JSON.stringify({}));
        }
        window.dispatchEvent(new Event("userNameChanged"));
      }
      if (
        response?.data?.data?.user?.permissions &&
        response?.data?.data?.user?.permissions?.length > 0
      ) {
        localStorage.setItem(
          "permissions",
          JSON.stringify(response?.data?.data?.user?.permissions)
        );
      }
      window.dispatchEvent(new Event("userTypeChanged"));
    } catch (error) {
      console.log("Something went wrong!");
    }
  };

  // Reset inactivity timer on user activity
  const resetInactivityTimer = useCallback(() => {
    setSeconds(INACTIVITY_TIMEOUT); // Reset to timeout duration
  }, [INACTIVITY_TIMEOUT]);

  // Use ref to track throttle timer
  const throttleTimerRef = useRef(null);

  // Set up activity listeners - always active, but only reset timer if logged in
  useEffect(() => {
    // Events that indicate user activity
    const activityEvents = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
      "click",
      "keydown"
    ];

    // Throttle function to avoid too many resets
    const throttledReset = () => {
      // Only reset if user is logged in (valid token)
      const isValidToken = IsTokenValid();
      if (!isValidToken) {
        return; // Don't reset if not logged in
      }

      // Reset timer immediately on user activity if token is valid
      // Throttle to prevent excessive state updates (max once per 100ms)
      if (throttleTimerRef.current) {
        return; // Reset already scheduled, skip to avoid excessive updates
      }
      
      // Reset immediately - this ensures continuous activity keeps timer at 3 hours
      resetInactivityTimer();
      
      // Set throttle flag to prevent rapid successive state updates
      throttleTimerRef.current = setTimeout(() => {
        throttleTimerRef.current = null;
      }, 100); // Allow reset every 100ms for responsive behavior
    };

    // Reset function that checks auth before resetting
    const safeReset = () => {
      const isValidToken = IsTokenValid();
      if (isValidToken) {
        resetInactivityTimer();
      }
    };

    // Add event listeners
    activityEvents.forEach((event) => {
      window.addEventListener(event, throttledReset, true);
    });

    // Also reset on focus (when user switches back to tab)
    window.addEventListener("focus", safeReset);

    // Also reset on visibility change (when user switches back to tab)
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        safeReset();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup
    return () => {
      activityEvents.forEach((event) => {
        window.removeEventListener(event, throttledReset, true);
      });
      window.removeEventListener("focus", safeReset);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      if (throttleTimerRef.current) {
        clearTimeout(throttleTimerRef.current);
        throttleTimerRef.current = null;
      }
    };
  }, [resetInactivityTimer]); // Include resetInactivityTimer in dependencies

  useEffect(() => {
    localStorage.setItem("moreOption", "close");
  }, []);

  // Countdown timer - only runs when user is inactive
  useEffect(() => {
    const isValidToken = IsTokenValid();
    if (!isValidToken) {
      return; // Don't run countdown if token is invalid
    }

    let subscription = localStorage.getItem("subscription");
    if (subscription) {
      try {
        subscription = JSON.parse(subscription);
      } catch (e) {
        subscription = null;
      }
    }
    
    // Only start countdown if user is logged in and has active subscription
    // If subscription is empty object or missing, still allow countdown (token is valid)
    if (subscription && typeof subscription === 'object' && Object.keys(subscription).length > 0 && !subscription?.active) {
      return; // Only stop countdown if subscription explicitly exists and is not active
    }

    const interval = setInterval(() => {
      if (seconds < 1) {
        clearInterval(interval);
        const Email = localStorage.getItem("email");
        const Password = localStorage.getItem("password");
        localStorage.clear();
        if (Email && Password) {
          localStorage.setItem("email", Email);
          localStorage.setItem("password", Password);
        }
        localStorage.setItem("session", "Yes");
        // navigate(`/login`);
        return;
      } else {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  // Initialize timer on mount if user is logged in
  useEffect(() => {
    const isValidToken = IsTokenValid();
    if (!isValidToken) {
      return;
    }

    let subscription = localStorage.getItem("subscription");
    if (subscription) {
      try {
        subscription = JSON.parse(subscription);
      } catch (e) {
        subscription = null;
      }
    }

    // Initialize timer if token is valid
    // Only check subscription.active if subscription exists and is not empty
    const hasActiveSubscription = !subscription || 
      (typeof subscription === 'object' && Object.keys(subscription).length === 0) ||
      subscription?.active !== false;
    
    if (hasActiveSubscription) {
      getUserData();
      // Initialize timer if not set from server
      resetInactivityTimer();
    }
  }, [resetInactivityTimer]);
  // const minutes = Math.floor(seconds / 60);
  // const remainingSeconds = seconds % 60;
  const networkError = localStorage.getItem("network");
  const sessionExpired = localStorage.getItem("session");
  return (
    <Provider store={store}>
      <div
        className={`App ${(networkError || sessionExpired) && "app_container"}`}
      >
        {networkError && networkError === "Yes" ? <NoInternetError /> : ""}
        {sessionExpired && sessionExpired === "Yes" ? <SessionExpired /> : ""}
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/about-us" element={<Aboutus />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact-us" element={<Contactus />} />
          <Route path="/verifyOtp" element={<VerifyOtp />} />

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/set-your-password" element={<SetYourPassword />} />
          <Route path="/user-invite" element={<UserInvite />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/chats" element={<Chat />} />
            <Route path="/onboarding" element={<OnBoardingForm />} />
            <Route path="/create-account" element={<CreateAccount />} />
            <Route path="/*" element={<CustomRoutes />} />
          </Route>
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </div>
    </Provider>
  );
}

export default App;
